import { selectOfferAgent, isNewbuildingSelector, offerSelector } from './offerData';
import { IState } from '../store';
import { isDeveloperCanCallback } from '../utils/isDeveloperCanCallback';

export const getIsCallbackAvailable = (state: IState): boolean => {
  const isNewbuilding = isNewbuildingSelector(state);
  const agent = selectOfferAgent(state);
  const offer = offerSelector(state);

  return isNewbuilding && isDeveloperCanCallback(agent, offer.isDealRequestSubstitutionPhone);
};
